<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iWJ5pg/tc-custom/9780310089650.jpg?1736624116198" alt="This image is the cover for the book 365 Devotions for a Thankful Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">365 Devotions for a Thankful Heart
      </h1>
      <p class="bookDescription body article font2">
        <p><b>No matter how difficult life seems, you will find more joy when you choose gratitude. Boost your happiness and deepen your walk with God by becoming aware of all you have to appreciate. <i>365 Devotions for a Thankful Heart </i>is a daily devotional that will inspire you to slow down, recognize God’s gifts, and be grateful for all His blessings.</b></p><p><b>This yearlong devotional includes:</b></p>a short daily reading encouraging you to open your heart with gratitude to all the ways God has blessed youan inspiring Scripture and a short prayer to help focus your heart on thankfulness as you go about your day<p>With a foiled cover and beautiful interiors, this devotional is a perfect gift for women of all ages on birthdays, Valentine’s Day, Mother’s Day, Christmas, or as a welcoming gift for new church members. Each devotion is the perfect length to fit into even the busiest schedule, but substantial enough to start your day on just the right note.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zondervan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ad5f1d30